// Copyright (c) 2023 Deere & Company

import FactoryDuplicatePinPlate from '../../product/factory-users-duplicate-pin-plate/state-connector';

export default {
    component: FactoryDuplicatePinPlate,
    name: 'FACTORY_DUPLICATE_PIN_PLATE',
    path: 'factory-shipping-info'
};




// WEBPACK FOOTER //
// ./src/routes/products/factory-duplicate-pin-plate-route.js